/** The name of analytics event with selected shopping context data. */
export const ShoppingContextDataEvent = 'shopping-context-data';

/** Partial shopping session context data to be forwarded into analytics. */
export interface ShoppingContextData {
  rewardPoints: number | null;
}
